import React, { useEffect, useState } from 'react';
import { Button, Drawer, Form, Input, Select, message, Modal, Result, Statistic } from 'antd';
import { CaptureTransaction } from '../../../apis/Brand/Credit/CaptureTransaction';
import { CreateOrder } from '../../../apis/Brand/Credit/CreateOrder';
import { Config } from '../../../Config';
import { dispatch, useGlobalState } from '../../../store/state';
import { caculateTAX, caculateTDS, scriptInject } from '../../../utils';
import CurrencyIcon from '../../Common/CurrencyIcon';
import './CreditPaymentForm.styles.scss';
import { DeductFromWallet } from '../../../apis/Brand/Credit/DeductFromWallet';

const { Item } = Form;
const { Option } = Select;
const CreditPaymentForm = ({ visible, onClose, cost, campId, pendingPayment }) => {
  const [paymentForm] = Form.useForm();
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const [prefillData, setPrefillData] = useState({
    netCost: cost,
  });
  const [paymentMode, setPaymentMode] = useState('onlinepayment');

  // @note: action after success full payment & captured that transction
  const paymentSuccess = (txnId, balance) =>{
    // @note: update balance in UI Store
    dispatch({
      type: 'SET_COMPANY',
      payload: {
        ...company,
        credit: {
          ...company.credit,
          balance: balance || company.credit.balance,
        },
      },
    });
    // note: closing payment drawer
    onClose();

    // note: clearing inputs
    paymentForm.resetFields();

    // @note: distroy if old modal there
    Modal.destroyAll();

    // @note: success modal show and will close after 15 sec
    Modal.success({
      width: 600,
      title: 'Successfully Added Amount into your Wallet',
      content: `Your Transaction ID: ${txnId || 'n/a'}`,
    });
  };

  // @note: If payment success and failed in capturing step( step2)
  const paymentCaptureFail = () =>{
    // @note: distroy if old modal there
    Modal.destroyAll();
    Modal.warning({
      // width:600,
      title: 'There is some issue with your Payment',
      content: 'Will update status as soon as it processed',
    });
  };

  // @note: If payment failed from gateway
  const paymentFail = () =>{
    // @note: distroy if old modal there
    Modal.destroyAll();
    Modal.error({
      // width:600,
      title: 'Your Payment got Failed.',
      content: `Please try Again`,
    });
  };

  // @note: update amount if it present
  const readyToUse = () => {
    // let _pre;
    if (pendingPayment) {
      const _pre = {
        baseAmount: cost,
        gst: caculateTAX(cost, Config.payment.tax.roi_gst),
        tds: caculateTDS(cost, Config.payment.tax.roi_tds),
      };
      _pre.netCost = (_pre.baseAmount + _pre.gst) - _pre.tds;
      setPrefillData(() => _pre);
      // console.log(..._pre)

      // check to disable gateway option
      setPaymentMode(
        company.credit.balance >= prefillData.netCost ? 'wallet': 'onlinepayment',
      );
    }
  };

  useEffect(()=>{
    paymentForm.setFieldsValue({
      'amount': prefillData.netCost || undefined,
      'paymentmethod': pendingPayment ? setInitPaymentMethod(prefillData.netCost) : 'onlinepayment',
    });
  }, [prefillData]);

  const setInitPaymentMethod = (net) =>{
    const _res = company.credit.balance >= net ? 'wallet': 'onlinepayment';
    setPaymentMode(_res);
    return _res;
  };

  // @note: initiating payment process
  const proceedToPay = ({ amount, paymentgateway, paymentmethod }) =>{
    console.log('campId', campId);
    // @note: form collected data
    const _data = {
      amount,
      paymentgateway,
      paymentmethod,
      brand: company.selected.id,
    };


    if (paymentmethod === 'wallet') {
      DeductFromWallet(user.accessToken, {
        amount,
        paymentmethod,
        campaignid: campId,
        brand: company.selected.id,
        paymentgateway: paymentmethod,
      }).then(({ status, response })=>{
        console.log('wallet payment success --> ', response);
        if (status === 200) {
          paymentSuccess(response.transactionid, response.balance);
        } else {
          message.error('there some issue while deducting amount from wallet');
        }
      });
    } else {
      if (pendingPayment) {
        _data.campaignid = campId;
      }
      // @note: step 1 - creating order
      CreateOrder(user.accessToken, _data).then(({ response, status })=>{
        // @note: if successfully created order
        if (status === 200) {
          const { currency, payment: { razorpay } } = Config;

          // @note: preparing razorpay opttions
          const _prepOptions = {
            'amount': _data.amount * currency.base,
            'key': razorpay.key,
            'currency': currency.type,
            'order_id': response.orderid,
            'description': 'Flynt Transaction',
            'prefill': razorpay.prefill,
            'handler': function ({ razorpay_payment_id, razorpay_signature }) {
              // @note: Payment successfully complted
              const _data = {
                transactionid: response.transactionid, // @note: transation id from step 1
                paymentid: razorpay_payment_id,
                signature: razorpay_signature,
              };
              // @note: add campiagn id for campaign specific Transaction
              if (campId) {
                _data.campaignid = campId;
              }
              console.log('res from razor', _data);

              // @note: step 2 - capturing transction details
              CaptureTransaction(user.accessToken, _data).then(({ response, status })=>{
                console.log('result', response);
                if (status === 200) {
                  // @note: updating Payment status into UI and show success message
                  paymentSuccess(_data.transactionid, response.balance_amount);
                } else {
                  console.log('issue while updating balance', response);

                  // @note: Will show step 2 failure and capture transction issue
                  paymentCaptureFail();
                }
              });
            },
          };

          // @note: razorpay init and inject razorpay script
          const displayRazorpay = async () => {
            const res = await scriptInject('https://checkout.razorpay.com/v1/checkout.js');
            if (!res) {
              message.error('Error loading Payment Gateway');
            } else {
              // note: init gateway with options
              const rzp1 = new window.Razorpay(_prepOptions);

              // note: triggering to open gateway modal
              rzp1.open();

              // note: if payment failed status from gateway
              rzp1.on('payment.failed', function (response) {
                console.log('failed res', response);
                paymentFail();
              });
            }
          };
          displayRazorpay();
        } else {
          // note: step 1 - if step 1 createorder failed
          message.error('There is some issue with payment, please try after some time');
        }
      });
    }
  };

  const paymentModeOnChange = (value) =>{
    // console.log("e",e)
    setPaymentMode(value);
    // if(prefillData.baseAmount >= company.credit.balance){
    //     setPaymentMode("wallet")
    // }else{
    //     setPaymentMode("onlinepayment")
    // }
  };
  return (
    <Drawer
      title="Add your credits"
      placement="right"
      width={300}
      onClose={onClose}
      visible={visible}
      destroyOnClose={true}
      afterVisibleChange={readyToUse}


    >
      <Form
        onFinish={proceedToPay}
        form={paymentForm}
        layout="vertical"
        requiredMark={false}
        // onChange={paymentFormOnChange}
        name="paymentForm"
        // initialValues={{
        //     "amount":prefillData.netCost || undefined
        // }}
      >
        <Item
          label="Amount"
          name="amount"
          rules={[{ required: true, message: 'Please provide you amount' }]}
        >
          <Input
            disabled={pendingPayment?true:false}
            className="common_input"
            type="number"
            size="large"
            placeholder="Enter your amount"
            prefix={CurrencyIcon()}/>
        </Item>
        {
          pendingPayment ?(
            <div className="cost_info mb-3">
              <div className="d-flex">
                <span>Campaign cost:</span>
                <span>{prefillData.baseAmount}</span>
              </div>
              <div className="d-flex text-secondary">
                <span className="child_type">[+] IGST @18%:</span>
                <span>{prefillData.gst}</span>
              </div>
              <div className="d-flex">
                <span className="text-success child_type">[-] TDS @10%:</span>
                <span className="text-success">{prefillData.tds}</span>
              </div>
              <hr className="my-1"/>
              <div className="d-flex pt-1">
                <span><strong>Net Payable:</strong></span>
                <span>
                  <strong><Statistic className="custom_number_format"
                    value={prefillData.netCost}
                    precision={2}
                    prefix={CurrencyIcon()}/></strong>
                </span>
              </div>
            </div>
          ):null
        }
        {/* <div className="py-1"></div> */}
        <Item
          label="Payment Method"
          name="paymentmethod"
          initialValue={paymentMode}

          rules={[{ required: true, message: 'Please select Payment Method' }]}
        >
          <Select
            onChange={paymentModeOnChange}
            className="common_select"
            size="large"
            placeholder="Select Payment Method"
          >
            <Option value="onlinepayment">Online Payment</Option>
            {
              prefillData.netCost <= company.credit.balance ?
                <Option value="wallet">Wallet</Option>:
                null
            }
          </Select>
        </Item>
        {/* <div className="py-1"></div> */}
        <Item
          label="Payment Gateway"
          name="paymentgateway"
          initialValue="razorpay"
          rules={[{ required: true, message: 'Please select Payment Gateway' }]}
        >
          <Select
            // disabled={paymentForm && paymentForm.getFieldValue('paymentmethod') === 'wallet' ? true:false}
            disabled={paymentMode === 'onlinepayment' ? false:true}
            className="common_select"
            size="large"
            placeholder="Select Payment Gateway">
            <Option value="razorpay">Razorpay</Option>
          </Select>
        </Item>

        <div className="py-1"></div>
        <Item>
          <Button className="common_button"
            htmlType="submit">Proceed to Pay</Button>
        </Item>
      </Form>
    </Drawer>
  );
};

export default CreditPaymentForm;
